<script setup lang="ts">
const { visible } = useLogin()
const tabActive = ref(2)
const { locale } = useI18n()
const isZhCN = computed(() => locale.value === 'zh')
const { isBrHost } = useJudgeBrHost()
const options = computed(() => {
  return !isZhCN.value || isBrHost.value
  // return !isZhCN.value
    ? [
        { label: '邮箱登录', value: 3 },
      ]
    : [{
        label: '手机号登录',
        value: 2,
      }]
})
const isPhone = ref(true)
watch(() => options.value, () => {
  tabActive.value = options.value[0].value
}, { immediate: true })
const isPassword = ref(true)
const step = ref(1)
const isReset = ref(false)
function forgetPwd() {
  step.value = 2
  isReset.value = true
}
const title = computed(() => {
  return isReset.value ? '重置密码' : tabActive.value === 2 ? '手机号注册' : '邮箱账号注册'
})
function reset() {
  step.value = 1
  isPassword.value = true
  isReset.value = false
}
watch(() => tabActive.value, () => {
  isPassword.value = true
})
watch(() => visible.value, () => {
  if (!visible.value) {
    reset()
  }
})
const user = useUser()
watch(() => user.value.isLogin, () => {
  visible.value = false
})
const localePath = useLocalePath()
const loading = ref(false)
const { isMiddleWidth, isMinWindowWidth } = useResponsiveLayout()
const iconSize = computed(() => {
  if (isMinWindowWidth.value) {
    return 16
  }
  else if (isMiddleWidth.value) {
    return 32
  }
  else {
    return undefined
  }
})
watch(isMiddleWidth, () => {
  visible.value = false
})
const { width } = useWindowSize()
const isMin1100 = ref(false)
function getMainWidth() {
  if (width.value < 1100) {
    isMin1100.value = true
  }
  else {
    isMin1100.value = false
  }
}
onMounted(() => {
  getMainWidth()
})
watch(width, () => {
  getMainWidth()
})
const getModalWidth = computed(() => {
  if (isMiddleWidth.value) {
    return '22.33rem'
  }
  else if (isMin1100.value) {
    return 860
  }
  else {
    return 940
  }
})
</script>

<template>
  <a-modal
    v-model:visible="visible"
    unmount-on-close
    :footer="false"
    :width="getModalWidth"
    simple
    modal-class="g-login__modal"
    hide-title
    :mask-closable="false"
    @cancel="visible = false"
  >
    <a-spin v-if="!isMiddleWidth" :loading="loading" :tip="$t('登录处理中，请稍候...')" :size="40">
      <div flex justify-end class="g-login-modal relative rd-24" :class="isMin1100 ? 'w-860' : 'w-940'">
        <span class="absolute right--70 top--10 h-42 w-42 flex cursor-pointer items-center justify-center rd-full bg-[--color-text-1] pl-1 text-20 text-white hover:op-80" @click="visible = false"><i class="icon-shanchu" /></span>
        <g-svg name="glodastory-logo" :width="111" :height="32" class="absolute left-30 top-30 text-black" />
        <!-- <div
        v-if="step === 1"
        class="absolute right-0 top-0 box-border h-64 w-64 flex cursor-pointer items-center justify-center border-32 border-b-transparent border-l-transparent border-r-[--color-fill-3] border-t-[--color-fill-3] rd-rt-24 border-solid text-[--color-text-3] hover:border-r-[--color-brand-3] hover:border-t-[--color-brand-3] hover:text-[--color-brand-6]"
      >
        <g-svg :name="isPhone ? 'login/qrcode' : 'login/phone'" :width="44" :height="44" class="mt-1" @click="isPhone = !isPhone" />
      </div> -->
        <div v-if="step === 2" class="absolute left-516 top-20 cursor-pointer text-16 text-[--color-text-2] hover:op-80" @click="reset">
          <g-svg name="login/left" />
        </div>
        <div box-border pb-50 pt-90 :class="[{ '!px-58': locale === 'en' }, isMin1100 ? 'w-370 px-30' : ' w-450 px-69']">
          <template v-if="isPhone">
            <div
              v-if="step === 1"
              relative mb-30 flex justify-center
            >
              <div
                v-for="item in options"
                :key="item.value"
                class="text-28 text-[--color-text-5] font-500"
                @click="tabActive = item.value"
              >
                {{ $t(item.label) }}
              </div>
              <div
                v-if="options.length > 1"
                class="absolute bottom--4 left-60 h-3 w-40 rd-8 bg-[--color-brand-6] transition-all duration-300"
                :class="{ '!left-228': tabActive === 3 }"
              />
            </div>
            <div v-else class="mb-28 mt--38 flex justify-center text-28 text-[--color-text-5]">
              {{ $t(title) }}
            </div>
          </template>
          <LoginForm
            v-if="isPhone"
            :step="step"
            :type="tabActive"
            :isPassword="isPassword"
            :isReset="isReset"
            isResizeIconSize
            @change="isPassword = !isPassword"
            @forget="forgetPwd"
          />
          <LoginQrcode v-else />
          <template v-if="step === 1">
            <a-divider orientation="center" :margin="26">
              <span class="block w-max text-[--color-text-3] font-400">{{ $t('其他登录方式') }}</span>
            </a-divider>
            <LoginGoogleButton v-model:loading="loading" />
          </template>
          <div v-if="!isReset" class="flex flex-col items-center text-[--color-text-3]">
            <span v-if="isPassword && isPhone" mt-16 @click="step = step === 1 ? 2 : 1">
              <template v-if="isZhCN">{{ $t(step === 1 ? '暂无账号' : '已有账号') }}?</template> <span class="cursor-pointer text-[--color-brand-6] hover:op-80">{{ $t(step === 1 ? '去注册' : '去登录') }}
                <g-tag
                  shape="square"
                  color="purple"
                  class="font-500 !bg-[--color-brand-2] !px-8"
                >
                  {{ $t('加客服领会员') }}
                </g-tag></span>
            </span>
            <span class="mt-16 flex flex-wrap justify-center text-12">
              <span>{{ $t('登录即表示已阅读并接受') }}</span>
              <!-- <NuxtLink :to="localePath('/agreement')" target="_blank" class="mx-4 cursor-pointer text-[--color-text-1] !text-12 hover:text-[--color-text-1] hover:underline" :hoverable="false">{{ $t('用户协议') }}</NuxtLink>
            <span>{{ $t('与') }}</span> -->
              <NuxtLink :to="localePath('/privacy')" target="_blank" class="mx-4 cursor-pointer text-[--color-text-1] !text-12 hover:text-[--color-text-1] hover:underline" :hoverable="false">{{ $t('隐私条款') }}</NuxtLink>
            </span>
          </div>
        </div>
      </div>
    </a-spin>
    <a-spin v-else :loading="loading" class="block w-full" :size="40">
      <span class="mobile-close" @click="visible = false"><i class="icon-shanchu" /></span>
      <div v-if="step === 2" class="mobile-back" @click="reset">
        <g-svg :width="iconSize" :height="iconSize" name="login/left" />
      </div>
      <div class="login-modal-mobile">
        <div class="mobile-title">
          <span v-if="step === 1">
            {{ $t(options[0]?.label) }}
          </span>
          <span v-else>
            {{ $t(title) }}
          </span>
        </div>
        <LoginForm
          :step="step"
          :type="tabActive"
          :isPassword="isPassword"
          :isReset="isReset"
          isResizeIconSize
          @change="isPassword = !isPassword"
          @forget="forgetPwd"
        />
        <template v-if="!isReset">
          <div v-if="isPassword && isPhone" class="mobile-text-btn" @click="step = step === 1 ? 2 : 1">
            {{ $t(step === 1 ? '去注册' : '去登录') }}
          </div>
          <LoginGoogleButton v-if="step === 1" v-model:loading="loading" :isMobile="isMiddleWidth" />
          <span class="mobile-privacy">
            <span>{{ $t('登录即表示已阅读并接受') }}</span>
            <NuxtLink :to="localePath('/privacy')" target="_blank" class="mx-4 cursor-pointer text-[--color-text-1] hover:text-[--color-text-1] hover:underline" :hoverable="false">《{{ $t('隐私条款') }}》</NuxtLink>
          </span>
        </template>
      </div>
    </a-spin>
  </a-modal>
</template>

<style scoped lang="less">
.g-login-modal {
  background: url(~/assets/images/login/bg.png) white no-repeat;
  background-size: 490 600;
  height: 600px;

}
:deep(.arco-spin-mask) {
  @apply 'rd-24';
}
:deep(.arco-spin-tip) {
  @apply 'text-18';
}
</style>

<style lang="less">
.g-login__modal {
  @apply 'rd-24 p-0';
}
.g-login__modal .arco-modal-body {
  overflow: unset !important;
}

@media screen and (max-width: 999px) {
  .g-login__modal {
    border-radius: 0.533rem;
    .arco-modal-body {
      font-size: 0.93333rem;
    }
    .mobile-back {
      position: absolute;
      left: 1rem;
      top: 0.5rem;
      cursor: pointer;
      color: var(--color-text-2);
      &:hover {
       opacity: .8;
      }
    }
    .mobile-close {
      position: absolute;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      background: var(--color-text-1);
      color: #fff;
      font-size: 1.066rem;
      left: 50%;
      bottom: -3.33rem;
      transform: translateX(-50%);
      &:hover {
        opacity: .8;
      }
    }
  }
  .login-modal-mobile {
    padding: 2rem 1.3333rem;
    .mobile-title {
      font-size: 1.6rem;
      line-height: 1.866rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 2rem;
    }
    .arco-input-wrapper {
      font-size: 0.93333rem;
    }

    .arco-input-wrapper .arco-input.arco-input-size-medium {
      font-size: 0.93333rem;
    }
    .arco-input-wrapper {
      padding-right: 1.333333rem;
      padding-left: 1.333333rem;
      height: 3.2rem;
      border-radius: 0.5333rem;
    }
    .arco-form-item:not(.arco-form-item-error):not(:last-child) {
      margin-bottom: 1.06666rem;
    }
    .arco-form-item-message {
      min-height: 1.06666rem;
      font-size: 0.7333rem;
    }
    .login-form-desc {
      padding: 0.5333rem;
      line-height: 1.46666rem;
    }
    .g-login-btn {
      font-size: 1.066rem;
      border-radius: 0.53333rem;
      height: 3.2rem;
    }
    .mobile-text-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.5333rem;
      font-size: 0.9333rem;
      padding: 0.5333rem;
      line-height: 1.46666rem;
      cursor: pointer;
      color: var(--color-brand-6);
    }
    .gala-google-btn {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .nsm7Bb-HzV7m-LgbsSe {
      width: 100% !important;
      max-width: 100% !important;
      font-size: 0.93333rem;
      height:2.666rem !important;
      border: 0;
      .nsm7Bb-HzV7m-LgbsSe-Bz112c {
        height: 1.6666rem;
        min-width: 1.6666rem;
        width:1.6666rem;
      }
     .oXtfBe-l4eHX .nsm7Bb-HzV7m-LgbsSe-BPrWId {
        display: none;
      }
    }
    .mobile-privacy {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 1.6rem;
      font-size: 0.8;
      color: var(--color-text-4);
    }

  }

}
</style>
